var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDwg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.011,
    height: 25.545,
    viewBox: "0 0 20.011 25.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dwg-svgrepo-com",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14167",
    "data-name": "Trazado 14167",
    d: "M48.6,0H32.842V25.545H52.853V4.257Z",
    transform: "translate(-32.842)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_460",
    "data-name": "Grupo 460",
    transform: "translate(0 1.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14168",
    "data-name": "Trazado 14168",
    d: "M98.249,80.439H94.237V76.427h4.012v4.012Zm-3.591-.421h3.169V76.848H94.658Z",
    transform: "translate(-89.064 -71.052)",
    fill: "#fb9200"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1608",
    "data-name": "Rect\\xE1ngulo 1608",
    width: 0.421,
    height: 5.586,
    transform: "translate(6.968)",
    fill: "#fb9200"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1609",
    "data-name": "Rect\\xE1ngulo 1609",
    width: 5.383,
    height: 0.421,
    transform: "translate(0 7.17)",
    fill: "#fb9200"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1610",
    "data-name": "Rect\\xE1ngulo 1610",
    width: 0.421,
    height: 5.923,
    transform: "translate(6.968 9.176)",
    fill: "#fb9200"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1611",
    "data-name": "Rect\\xE1ngulo 1611",
    width: 11.037,
    height: 0.421,
    transform: "translate(8.974 7.17)",
    fill: "#fb9200"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14169",
    "data-name": "Trazado 14169",
    d: "M49.254,2.129H32.842V0H48.6Z",
    transform: "translate(-32.842)",
    fill: "#004a94"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_462",
    "data-name": "Grupo 462",
    transform: "translate(3.264 18.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_461",
    "data-name": "Grupo 461"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14170",
    "data-name": "Trazado 14170",
    d: "M75.008,227.827a2.088,2.088,0,0,1-.557,1.559,2.14,2.14,0,0,1-1.566.547H71.577v-4.042h1.4a2.111,2.111,0,0,1,1.5.5A1.878,1.878,0,0,1,75.008,227.827Zm-1.134.039a1.285,1.285,0,0,0-.22-.824.813.813,0,0,0-.668-.268h-.318v2.264h.243a.881.881,0,0,0,.73-.289A1.4,1.4,0,0,0,73.875,227.866Z",
    transform: "translate(-71.577 -225.834)",
    fill: "#a4a9ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14171",
    "data-name": "Trazado 14171",
    d: "M121.451,229.934H120.16l-.387-1.761q-.028-.111-.087-.44t-.087-.55q-.022.18-.072.447t-.1.491q-.048.224-.4,1.814h-1.291l-1-4.042h1.053l.44,2.027q.149.672.2,1.07.036-.282.128-.766t.173-.8l.357-1.529H120.1l.346,1.529q.088.368.18.849t.122.719q.036-.307.2-1.065l.448-2.032h1.053Z",
    transform: "translate(-112.929 -225.833)",
    fill: "#a4a9ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14172",
    "data-name": "Trazado 14172",
    d: "M190.737,226.936h1.745v2.179a4.8,4.8,0,0,1-1.562.243,1.888,1.888,0,0,1-1.445-.542,2.17,2.17,0,0,1-.51-1.546,2.031,2.031,0,0,1,.559-1.524,2.147,2.147,0,0,1,1.565-.545,3.469,3.469,0,0,1,.72.072,3.051,3.051,0,0,1,.59.182l-.346.857a2.137,2.137,0,0,0-.959-.216.912.912,0,0,0-.74.311,1.346,1.346,0,0,0-.261.889,1.364,1.364,0,0,0,.236.864.82.82,0,0,0,.682.3,2,2,0,0,0,.448-.047v-.633h-.722v-.843Z",
    transform: "translate(-179.075 -225.202)",
    fill: "#a4a9ad"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14173",
    "data-name": "Trazado 14173",
    d: "M219.821,4.257h4.257L219.821,0Z",
    transform: "translate(-204.067)",
    fill: "#d1d3d3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDwg);
export default __webpack_public_path__ + "static/media/dwg.74e9ee9b5be27678195dde16f4822a98.svg";
export { ForwardRef as ReactComponent };